import { lazy, Suspense } from 'react';

import { ClassicExperience } from '@/console/app/classic-experience';
import { resolveExperience } from '@/console/host/resolve-experience';
import { AuthLoader } from '@/shared/components/ui/auth-loader/auth-loader';
import { useFeatureFlag } from '@/shared/hooks/use-feature-flag/use-feature-flag';
import { FEATURE_MODERN_UI } from '@/shared/hooks/use-feature-flag/use-feature-flag.constants';
import { ModernSplash } from '@modern/components/ui/splash/splash';

const ModernExperience = lazy(() =>
  import('@/console/host/modern-experience-shell').then((module) => ({
    default: module.ModernExperienceShell,
  })),
);

export const ExperienceGate = () => {
  const optedIntoModern =
    resolveExperience(window.location.pathname) === 'modern';

  const { isFeatureFlagEnabled, isLoading } = useFeatureFlag({
    skip: !optedIntoModern,
  });

  if (!optedIntoModern) {
    return <ClassicExperience />;
  }

  if (isLoading) {
    return <ModernSplash />;
  }

  if (!isFeatureFlagEnabled(FEATURE_MODERN_UI)) {
    return <ClassicExperience />;
  }

  // AuthLoader first: the permissions provider inside the shell skips its policy
  // read until the user is in the store, and still builds a model that denies every check.
  return (
    <AuthLoader renderLoading={() => <ModernSplash />}>
      <Suspense fallback={<ModernSplash />}>
        <ModernExperience />
      </Suspense>
    </AuthLoader>
  );
};
